module.exports = __webpack_public_path__ + "img/receiver.c2839e9d.svg";